var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('PageGuide',{attrs:{"description":"This page provides general information about the ORFanID application.","steps":[
      'Read the page overview to understand the purpose of ORFanID.',
      'Use the main navigation to access sequence submission, results, instructions, ORFanBase, or accession search.',
      'Return to the home page when you want to start from the ORFanID introduction.'
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }